import { call, delay, put, takeLatest } from 'redux-saga/effects';

import { GET_SEARCH_IMAGE, getSearchImageAsyncInImageTab } from './actions';
import { GetSearchImageType } from '../../lib/tabImage/type';
import { apiGetSearchImage } from '../../lib/tabImage/api';

function* getSearchImageSaga(
  action: ReturnType<typeof getSearchImageAsyncInImageTab.request>
) {
  try {
    yield delay(500);
    const data: GetSearchImageType = yield call(
      apiGetSearchImage,
      action.payload
    );
    yield put(getSearchImageAsyncInImageTab.success(data));
  } catch (error) {
    yield put(getSearchImageAsyncInImageTab.failure(error));
  }
}

export default function* tabImageSaga() {
  yield takeLatest(GET_SEARCH_IMAGE, getSearchImageSaga);
}
